import { combineReducers } from "redux";
import CargoControlNumberReducer from "./CargoControlNumberReducer";
import ImporterReducer from "./ImporterReducer";
import SubHrdReducer from "./SubHrdReducer";
import FormReducer from "./FormReducer";
import DescriptionOfInvoiceReducer from "./DescriptionOfInvoiceReducer";
import DescriptionOfMerchandiseReducer from "./DescriptionOfMerchandiseReducer";
import DropDownReducer from "./DropDownReducer";
import DeclarationSectionReducer from "./DeclarationSectionReducer";
import FieldValidationReducer from "./FieldValidationReducer";
import TransactionNumberReducer from "./TransactionNumberReducer";
import CargoSectionReducer from "./CargoSectionReducer";
import TotalsSectionReducer from "./TotalsSectionReducer";
import EcccFlagReducer from "./EcccFlagReducer";
import NotesReducer from "./Notes.Reducer";
import MerchBehaviourReducer from "./MerchBehaviourReducer";
import showCfiaReducer from "./showcfiaReducer";
import ShipmentLevelReducer from "./shipmentLevelReducer";
import FormValidationReducer from "./FormValidationReducer";
import savePgaOnGivenHtsReducer from "./SavePgaOnHtsReducer";
import DeltaUpdateReducer from "./DelteUpdateReducer";
import IntakeReducer from "./IntakeReducer";

function createReducer(asyncReducers) {
  return combineReducers({
    Intake:IntakeReducer,
    Shipment: ShipmentLevelReducer,
    DropDownValues: DropDownReducer,
    TransactionNumber: TransactionNumberReducer,
    CargoControl: CargoControlNumberReducer,
    Importer: ImporterReducer,
    DescriptionOfInvoice: DescriptionOfInvoiceReducer,
    DescriptionOfMerchandise: DescriptionOfMerchandiseReducer,
    FormValues: FormReducer,
    DeclarationSection: DeclarationSectionReducer,
    CargoSection: CargoSectionReducer,
    FieldValidation: FieldValidationReducer,
    PgaData: savePgaOnGivenHtsReducer,
    SubHrd: SubHrdReducer,
    PgaFlag: EcccFlagReducer,
    Totals: TotalsSectionReducer,
    NotesReducer: NotesReducer,
    showCfiaReducer: showCfiaReducer,
    MerchBehaviourReducer: MerchBehaviourReducer,
    FormValidationReducer: FormValidationReducer,
    DeltaUpdateForPga: DeltaUpdateReducer,

    ...asyncReducers,
  });
}

export { createReducer };
